import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';

import amplitude from './amplitude';

const trackViewAllButtonClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.ALL_BADGES_VIEWED);
};

const trackBadgeDetailsClick = (trackingValue) => {
    if (!trackingValue) return;

    amplitude.trackWithPageId(amplitudeEventNames.BADGE_DETAILS_OPENED, {
        [analyticsEventProperties.TRACKING_VALUE]: trackingValue,
    });
};

export default {
    trackViewAllButtonClick,
    trackBadgeDetailsClick,
};
